var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { width: "24", height: "24", rx: "4", fill: "#F3F3F3" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.0605 11.9998L17.5302 16.4695C18.2373 17.1766 17.1766 18.2373 16.4695 17.5302L11.9998 13.0605L7.53018 17.5302C6.82307 18.2373 5.76241 17.1766 6.46952 16.4695L10.9392 11.9998L6.46952 7.53018C5.76241 6.82307 6.82307 5.76241 7.53018 6.46952L11.9998 10.9392L16.4695 6.46952C17.1766 5.76241 18.2373 6.82307 17.5302 7.53018L13.0605 11.9998Z", fill: "#9B9B9B" })
  );
});